export const ar = {
	home: "الرئيسية",
	"my account": "حسابي",
	"Our products": "منتجاتنا",
	"about home description":
		"الشركة كورني شركة كويتية وطنية من كبار مصنعي السناكس بدولة الكويت، و كورني مبنية على الجودة العالية - الصدق والنزاهة والاحترام والشفافية والثقة. تأسس المصنع عام 2004 .",
	search: "البحث",
	"Login Successfully.": "تم تسجيل الدخول بنجاح.",
	"Register Successfully.": "تم التسجيل بنجاح.",
	"Products designed to fit your routine simply and effectively.":
		"منتجات صُممت لتلائم روتينك بكل بساطة وفعالية.",
	products: "المنتجات",
	"Your cart is empty!": "سلة التسوق الخاصة بك فارغة!",
	"Browse our categories and discover our best deals!":
		"تصفح فئاتنا واكتشف أفضل عروضنا!",
	"Back to shopping": "الرجوع للتسوق",
	"Application Summary": "ملخص الطلب",
	"Shop Now": "تسوق الأن",
	"Contact Us": "تواصل معنا",
	categories: "الأقسام",
	"about-us": "من نحن",
	quick_links: "روابط سريعة",
	Brand: "ماركة",
	"Shop By Category": "تسوق حسب القسم",
	"View All": "عرض الكل",
	All: "الكل",
	previous: "السابق",
	Description: "وصف",
	"filter by": "تصفية حسب",
	"Dynamic Variant": "اضافات بسعر",
	"Similar Products": "منتجات مماثلة",
	next: "التالي",
	"Cancel Message":
		"هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء، وسيتم فقد أي تقدم متعلق بالطلب.",
	results: "نتائج",
	"Explore All": "استكشاف الكل",
	Explore: "استكشف",
	"more Details": "المزيد من التفاصيل",
	"Feature Products": "المنتجات المميزة",
	QUALITY: "الجودة التي يقدمها لك MASTER HN",
	"Best Selling Products": "أفضل المنتجات مبيعا",
	"Featured Products": "المنتجات المميزة",
	"There's no Products": "لا يوجد منتجات",
	"Working Hours": "ساعات العمل",
	ordered: "تم الطلب",
	"ordered successfully": "شكرًا لك على طلبك",
	"ordered successfully description": "تم تقديم طلبك بنجاح",
	"ordered failed": "حدث خطأ ما!",
	"ordered failed description": "لم يتم استكمال الدفع",
	Cancel: "إلغاء",
	canceled: "تم الإلغاء",
	"Cancel Order": "إلغاء الطلب",
	done: "تم",
	close: "إغلاق",
	"Order Date": "تاريخ الطلب",
	status: "الحالة",
	"Order ID": "الرقم التعريفي للطلب",
	leadership: "القادة",
	"work team": "فريق العمل",
	View: "مشاهدة",
	"Our partners": "شركاؤنا",
	address: "العنوان",
	"My Address": "عنواني",
	"Profile Image": "صورة الملف الشخصي",
	Cash: "نقدي",
	cash: "نقدي",
	Knet: "كي نت",
	knet: "كي نت",
	"Cash in Delivery": "نقدا عند التسليم",
	canceled: "تم الإلغاء",
	"out of stock": "نفذ من المخزن",
	"Working Days": "أيام العمل",
	"Show Rooms": "صالات العرض",
	"Best seller": "الأكثر مبيعًا",
	Offers: "العروض",
	branches: "الفروع",
	brands: "العلامات التجارية",
	Contacts: "جهات الاتصال",
	"Follow us": "تابعنا",
	"New Arrivals": "المنتجات الجديدة",
	"DOWNLOAD MASTER HN": "تحميل Master HN",
	"Style Up Your Looks": "صمم مطبخك",
	"All Rights": "كل الحقوق محفوظة",
	"Hasan Al Naser": "حسن الناصر",
	"Powered By": "مدعوم من",
	"Total Price": "السعر الإجمالي",
	Continue: "متابعة",
	"Your Cart is Empty": "عربة التسوق فارغة",
	KWD: "د.ك",
	"Download Pdf": "تحميل الملف",
	"Style Up": "صمم",
	"Add To Cart": "أضف إلى السلة",
	contact: "اتصل بنا",
	Name: "الإسم",
	Email: "البريد الإلكتروني",
	Phone: "رقم الموبايل",
	Message: "الرسالة",
	"CONTACT US ON WHATSAPP": "تواصل معنا عبر واتساب",
	"GET IN TOUCH": "ابق على تواصل",
	Product: "المنتج",
	Price: "السعر",
	Quantity: "الكمية",
	"Quick links": "روابط سريعة",
	Total: "الإجمالي",
	subcategory: "الفئة الفرعية",
	terms: "الشروط",
	"term and conditions": "الشروط والأحكام",
	"Return Policy": "سياسة الإسترجاع",
	privacy_policy_return: "سياسة الخصوصية والاسترجاع",
	"Sub Total": "المجموع الفرعي",
	Payment: "الدفع",
	"Payment Details": "تفاصيل الدفع",
	"User Name": "اسم المستخدم",
	Proceed: "هل ترغب في المتابعة لإتمام الطلب كـ",
	Login: "تسجيل الدخول",
	"Continue as a Guest": "المتابعة كزائر",
	"Login Into Your Account": "تسجيل الدخول إلى حسابك",
	"Create New Account": "إنشاء حساب جديد",
	Password: "الرقم السري",
	"Don't Have Account": "ليس لديك حساب ؟",
	"Sign Up": "التسجيل",
	"Address Name": "اسم العنوان",
	"Have Account": "لديك حساب",
	Checkout: "إتمام الشراء",
	Governorate: "محافظة",
	Save: "حفظ",
	"User Details": "تفاصيل المستخدم",
	"Full Name": "الاسم الكامل",
	"Address Details": "تفاصيل العنوان",
	Area: "المنطقة",
	Block: "القطعه",
	Street: "الشارع",
	Avenue: "الجادة",
	"Floor Number": "رقم الطابق",
	Optional: "اختياري",
	"Address Type": "نوع العنوان",
	"Building Number": "رقم المبنى",
	Floor: "الطابق",
	"Apartment Number": "رقم الشقة",
	"House Number": "رقم المنزل",
	"Office Number": "رقم المكتب",
	"Extra Directions": "اتجاهات إضافية",
	"Other Instructions": "تعليمات أخرى",
	"Please Enter": "الرجاء إدخال",
	"Please Select": "الرجاء التحديد",
	House: "المنزل",
	Flat: "شقه",
	Office: "المكتب",
	"Coupon Code": "رمز الكوبون",
	Apply: "تطبيق",
	"Payment Method": "طريقة الدفع",
	KNET: "كي نت",
	"Visa/MasterCard": "فيزا/ماستركارد",
	visa: "فيزا/ماستركارد",
	"Payment Detail": "تفاصيل الدفع",
	Discount: "الخصم",
	"Delivery Charges": "رسوم التوصيل",
	"Submit Order": "ارسال الطلب",
	"show some love to your bag": "أظهر بعض الحب لحقيبتك",
	"Fill your bag with things that make you happy":
		"املأ حقيبتك بالأشياء التي تسعدك",
	Profile: "الصفحه الشخصيه",
	Logout: "تسجيل الخروج",
	"My Account": "حسابي",
	"My Orders": "طلباتي",
	"Update Account": "تحديث الحساب",
	Update: "تحديث",
	Account: "البيانات الشخصية",
	"Change Password": "تغيير كلمة المرور",
	"New Password": "كلمة المرور الجديدة",
	"Old Password": "كلمة المرور القديمه",
	"Confirm New Password": "تأكيد كلمة المرور الجديدة",
	"This Field is required": "هذه الخانة مطلوبه",
	Amount: "كميه",
	Add: "إضافة",
	"Buy it again": "اشتري مره أخري",
	"Add Address First": "اضف العنوان اولا",
	"There are No Products": "لا يوجد منتجات",
	"Product Added To Cart": "تم إضافة المنتج إلى سلة التسوق",
	"Forget Password?": "هل نسيت كلمه المرور؟",
	Default: "الافتراضية",
	"Forget Password": "نسيت كلمه المرور",
	Back: "الي الخلف",
	Delete: "حذف",
	"Address Added Successfully.": "تمت إضافة العنوان بنجاح.",
	"Address Updated Successfully.": "تمت تعديل العنوان بنجاح.",
	"Address Deleted Successfully.": "تمت حذف العنوان بنجاح.",
	"Message Sent Successfully.": "تم إرسال الرسالة بنجاح.",
	"First Name": "الاسم الأول",
	"Last Name": "اسم العائلة",
	"Message Required": "الرسالة المطلوبة",
	"promo code is invalid!": "الرمز الترويجي غير صالح!",
	"Successfully Applied": "تم التطبيق بنجاح",
	"Remove from Cart": "إزالة من السلة",
	Remove: "إزاله",
	Search: "بحث",
	"Classic kitchen": "مطبخ كلاسيكي",
	"Modern kitchen": "المطبخ الحديث",
	"No Address": "لا يوجد عنوان",
	"Add New Address": "إضافة عنوان جديد",
	"Set Default": "تعيين كافتراضي",
	Edit: "تعديل",
};
